<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        แก้ไขรายการส่งเสริมการขายโทรศัพท์เคลื่อนที่
        <small></small>
      </h1>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="row">
                <div class="col-sm-12">
                  <div class="col-sm-12">
                  <el-steps
                    :active="active"
                    finish-status="success"
                    simple
                    style="margin-top: 19px"
                  >
                    <el-step title="ขั้นตอนที่ 1" class="btn-step" @click.native="steps(0)"></el-step>
                    <el-step title="ขั้นตอนที่ 2" class="btn-step" @click.native="steps(1)"></el-step>
                    <el-step title="ขั้นตอนที่ 3" class="btn-step" @click.native="steps(2)"></el-step>
                    <el-step title="ขั้นตอนที่ 4" class="btn-step" @click.native="steps(3)"></el-step>
                    <el-step title="ขั้นตอนที่ 5" class="btn-step" @click.native="steps(4)"></el-step>
                    <el-step title="ขั้นตอนที่ 6" class="btn-step" @click.native="steps(5)"></el-step>
                    <el-step title="ขั้นตอนที่ 7" class="btn-step" @click.native="steps(6)"></el-step>
                    <el-step title="ขั้นตอนที่ 8" class="btn-step" @click.native="steps(7)"></el-step>
                    <el-step title="ขั้นตอนที่ 9" class="btn-step" @click.native="steps(8)"></el-step>
                  </el-steps>
                  </div>
                </div>
                <div class="col-sm-12">
                  <el-form
                    size="small"
                    :label-position="label_position"
                    label-width="100px"
                    :model="form"
                    ref="ruleForm"
                    class="demo-ruleForm"
                    >
                    <div v-if="active === 0" class="col-sm-12">
                      <el-form-item label="รหัสรายการส่งเสริมการขาย" required>
                        <el-input
                          show-word-limit
                          maxlength="20"
                          clearable
                          v-model="form.promotion_code"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="ชื่อรายการส่งเสริมการขาย (ภาษาไทย)" required>
                        <el-input
                          clearable
                          v-model="form.promotion_name_th"
                          show-word-limit
                          maxlength="100"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="ชื่อรายการส่งเสริมการขาย (ภาษาอังกฤษ)">
                          <el-input
                            clearable
                            v-model="form.promotion_name_en"
                            show-word-limit
                            maxlength="100"
                          ></el-input>
                      </el-form-item>
                      <el-form-item label="ประเภทบริการของรายการส่งเสริมการขาย" required>
                        <el-select
                          v-model="form.promotion_category"
                          filterable
                        >
                          <el-option
                            label="ระบบเติมเงิน (Prepaid)"
                            value="prepaid"
                          ></el-option>
                          <el-option
                            label="ระบบรายเดือน (Postpaid)"
                            value="postpaid"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="ชนิดของรายการส่งเสริมการขาย (รายการส่งเสริมการขายหลัก/รายการส่งเสริมการขายเสริม)" required>
                        <el-select
                          v-model="form.promotion_type"
                          filterable
                        >
                          <el-option label="รายการส่งเสริมการขายหลัก (Main)" value="main"></el-option>
                          <el-option label="รายการส่งเสริมการขายเสริม (On-top)" value="on-top"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="จำนวนวันการให้บริการของรายการส่งเสริมการขายเสริม (เฉพาะ On-Top)">
                        <el-input-number v-model="form.number_of_service_days" :precision="2" :step="1" :max="9999.99" :min="null" style="width: 220px"></el-input-number>
                      </el-form-item>
                      <div class="row">
                        <div class="col-sm-6">
                          <el-form-item label="วันเริ่มต้นของการเสนอขาย">
                            <el-date-picker
                              style="width:100%;"
                              v-model="form.start_sale_date"
                              type="date"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="วันสิ้นสุดของการเสนอขาย">
                              <el-date-picker
                                v-model="form.end_sale_date"
                                type="date"
                                style="width:100%;"
                              ></el-date-picker>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <el-form-item label="วันเริ่มต้นของการให้บริการ">
                            <el-date-picker
                              v-model="form.start_service_date"
                              type="date"
                              style="width:100%;"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="วันสิ้นสุดของการให้บริการ">
                              <el-date-picker
                                v-model="form.end_service_date"
                                type="date"
                                style="width:100%;"
                              ></el-date-picker>
                          </el-form-item>
                        </div>
                      </div>
                      <el-form-item label="สถานะการให้บริการ" required>
                        <el-select v-model="form.service_status">
                          <el-option label="รายการส่งเสริมการขายใหม่ (ยังขายอยู่)" value="s"></el-option>
                          <el-option label="ไม่ขายแล้วแต่ยังให้บริการอยู่" value="u"></el-option>
                          <el-option label="ยกเลิกการให้บริการแล้ว" value="x"></el-option>
                          <el-option label="Corporate รายการส่งเสริมการขายใหม่ (ยังขายอยู่)" value="cs"></el-option>
                          <el-option label="Corporate ไม่ขายแล้วแต่ยังให้บริการอยู่" value="cu"></el-option>
                          <el-option label="Corporate ยกเลิกการให้บริการแล้ว" value="cx"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="ค่าบริการเหมาจ่ายรวมตามสิทธิ์การใช้งาน (บาท)" width="500">
                        <el-input-number v-model="form.promotion_price" :precision="2" :step="10" :max="999999999.99" :min="null" style="width: 220px"></el-input-number>
                      </el-form-item>
                      <div class="col-xs-12" style="padding-bottom: 20px !important">
                        <div class="col-xs-3"></div>
                        <div class="col-xs-2"> </div>
                        <div class="col-xs-2">
                          <el-button
                            type="success"
                            @click="preview()"
                            >
                            บันทึก
                          </el-button>
                        </div>
                        <div class="col-xs-2"></div>
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-right"
                            @click="next()"
                            >
                            <i class="el-icon-right"></i>
                          </el-button>
                        </div>
                      </div>
                    </div>
                    <div v-if="active === 1" class="col-sm-12">
                      <el-form-item
                        label="ค่าบริการจำแนกตามประเภทบริการ (บาท)"
                      ></el-form-item>
                      <div class="row">
                        <div class="col-sm-6">
                          <el-form-item label="บริการเสียง (บาท)" prop="voice_service" >
                            <el-input-number v-model="form.voice_service" :precision="2" :max="9999999.99" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="บริการ SMS (บาท)" prop="sms_service" >
                            <el-input-number v-model="form.sms_service" :precision="2" :max="9999999.99" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <el-form-item label="บริการ MMS (บาท)" prop="mms_service" >
                            <el-input-number v-model="form.mms_service" :precision="2" :max="9999999.99" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="บริการ Internet (บาท)" prop="internet_service">
                            <el-input-number v-model="form.internet_service" :precision="2" :max="9999999.99" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <el-form-item label="WiFi (บาท)" prop="wifi_service">
                            <el-input-number v-model="form.wifi_service" :precision="2" :max="9999999.99" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="Others" prop="other_service">
                            <el-input-number v-model="form.other_service" :precision="2" :max="9999999.99" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="col-xs-12" style="padding-bottom: 20px !important">
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-left"
                            @click="back()"
                          >
                            <i class="el-icon-back"></i>
                          </el-button>
                        </div>
                        <div class="col-xs-2"> </div>
                        <div class="col-xs-2">
                          <el-button
                            type="success"
                            @click="preview()"
                            >
                            บันทึก
                          </el-button>
                        </div>
                        <div class="col-xs-2"></div>
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-right"
                            @click="next()"
                            >
                            <i class="el-icon-right"></i>
                          </el-button>
                        </div>
                      </div>
                    </div>
                    <div v-if="active === 2" class="col-sm-12"> 
                      <el-form-item label="สิทธิ์การใช้งานที่ผู้ใช้บริการได้รับจำแนกตามประเภทบริการ"></el-form-item>
                        <div class="col-sm-4">
                          <el-form-item label="บริการเสียง (นาที)">
                            <el-input-number v-model="form.voice_minute" :max="999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-4">
                          <el-form-item label="บริการเสียง (วินาที)">
                            <el-input-number v-model="form.voice_second" :max="999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-4">
                          <el-form-item label="โทรไม่จำกัด (Unlimited)">
                            <el-radio-group v-model="form.voice_unlimited" size="small">
                              <el-radio :label="1">ใช่</el-radio>
                              <el-radio :label="0">ไม่ใช่</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item label="เงื่อนไข (ภาษาไทย)">
                            <el-input
                              clearable
                              v-model="form.voice_remark_th"
                              show-word-limit
                              maxlength="500"
                              style="width:100%;"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item
                            label="เงื่อนไข (ภาษาอังกฤษ)"
                          >
                            <el-input
                              clearable
                              v-model="form.voice_remark_en"
                              show-word-limit
                              maxlength="500"
                              style="width:100%;"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      <br>
                        <div class="col-sm-6">
                          <el-form-item label="บริการ SMS (ข้อความ)">
                            <el-input-number v-model="form.sms_amount" :max="999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="บริการ MMS (ข้อความ)">
                            <el-input-number v-model="form.mms_amount" :max="999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                      <br>
                        <div class="col-sm-4">
                          <el-form-item label="บริการ Internet (MB)">
                            <el-input-number v-model="form.internet_MB" :precision="2" :max="999999999999.99" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-4">
                          <el-form-item label="บริการ Internet (GB)">
                            <el-input-number v-model="form.internet_GB" :precision="2" :max="9999999.99" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-4">
                          <el-form-item label="บริการ Internet ไม่จำกัด (Unlimited)">
                            <el-radio-group v-model="form.internet_unlimited" size="small">
                              <el-radio :label="1">ใช่</el-radio>
                              <el-radio :label="0">ไม่ใช่</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item label="เงื่อนไข (ภาษาไทย)">
                            <el-input
                              clearable
                              v-model="form.internet_remark_th"
                              show-word-limit
                              maxlength="500"
                              style="width:100%"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item label="เงื่อนไข (ภาษาอังกฤษ)">
                            <el-input
                              clearable
                              v-model="form.internet_remark_en"
                              show-word-limit
                              maxlength="500"
                              style="width:100%"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      <br>
                        <div class="col-sm-6">
                          <el-form-item label="ความเร็ว (Kbps)">
                            <el-input-number v-model="form.internet_speed_Kbps" :max="999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="ความเร็ว (Mbps)">
                            <el-input-number v-model="form.internet_speed_Mbps" :max="999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item
                            label="เงื่อนไข (ภาษาไทย)"
                          >
                            <el-input
                              clearable
                              v-model="form.internet_speed_remark_th"
                              show-word-limit
                              maxlength="100"
                              style="width:100%;"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item
                            label="เงื่อนไข (ภาษาอังกฤษ)"
                          >
                            <el-input
                              clearable
                              v-model="form.internet_speed_remark_en"
                              show-word-limit
                              maxlength="100"
                              style="width:100%;"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      <br>
                        <div class="col-sm-12">
                          <el-form-item label="Wifi คำอธิบาย (ภาษาไทย)">
                            <el-input
                              clearable
                              v-model="form.wifi_service_th"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item label="Wifi คำอธิบาย (ภาษาอังกฤษ)">
                            <el-input
                              clearable
                              v-model="form.wifi_service_en"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      <br>
                        <div class="col-sm-12">
                          <el-form-item label="Others คำอธิบาย (ภาษาไทย)">
                            <el-input
                              clearable
                              v-model="form.other_service_th"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item label="Others คำอธิบาย (ภาษาอังกฤษ)">
                            <el-input
                              clearable
                              v-model="form.other_service_en"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      <div class="col-xs-12" style="padding-bottom: 20px !important">
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-left"
                            @click="back()"
                          >
                            <i class="el-icon-back"></i>
                          </el-button>
                        </div>
                        <div class="col-xs-2"> </div>
                        <div class="col-xs-2">
                          <el-button
                            type="success"
                            @click="preview()"
                            >
                            บันทึก
                          </el-button>
                        </div>
                        <div class="col-xs-2"></div>
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-right"
                            @click="next()"
                            >
                            <i class="el-icon-right"></i>
                          </el-button>
                        </div>
                      </div>
                    </div>

                    <div v-if="active === 3" class="col-sm-12">
                      <el-form-item
                        label="อัตราค่าบริการเฉลี่ย (ทั้ง Postpaid และ Prepaid)"
                      ></el-form-item>
                      <div class="row">
                        <div class="col-sm-6">
                          <el-form-item label="บริการเสียง (บาท/นาที)">
                            <el-input-number v-model="form.voice_per_minute" :precision="10" :max="999.9999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="บริการเสียง (บาท/วินาที)">
                            <el-input-number v-model="form.voice_per_second" :precision="10" :max="999.9999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item label="เงื่อนไขอื่น ๆ">
                            <el-input
                              clearable
                              v-model="form.voice_remark"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-4">
                          <el-form-item label="บริการ SMS (บาท/ข้อความ)">
                            <el-input-number v-model="form.sms_per_message" :precision="10" :max="999.9999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-4">
                          <el-form-item label="บริการ MMS (บาท/ข้อความ)">
                            <el-input-number v-model="form.mms_per_message" :precision="10" :max="999.9999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-4">
                          <el-form-item label="บริการ Internet (บาท/MB)">
                            <el-input-number v-model="form.internet_per_MB" :precision="10" :max="999.9999999999" :min="null" style="width: 100%" clearable></el-input-number>
                          </el-form-item>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item label="Wifi (คำอธิบาย)">
                            <el-input
                              clearable
                              v-model="form.wifi_average"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item label="Others (คำอธิบาย)">
                            <el-input
                              clearable
                              v-model="form.other_average"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="col-xs-12" style="padding-bottom: 20px !important">
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-left"
                            @click="back()"
                          >
                            <i class="el-icon-back"></i>
                          </el-button>
                        </div>
                        <div class="col-xs-2"> </div>
                        <div class="col-xs-2">
                          <el-button
                            type="success"
                            @click="preview()"
                            >
                            บันทึก
                          </el-button>
                        </div>
                        <div class="col-xs-2"></div>
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-right"
                            @click="next()"
                            >
                            <i class="el-icon-right"></i>
                          </el-button>
                        </div>
                      </div>
                    </div>
                    <div v-if="active === 4" class="col-sm-12">
                      <el-form-item
                        label="อัตราค่าบริการต่อหน่วยในส่วนที่เกินกว่าสิทธิการใช้งานของแต่ละประเภทบริการ (เฉพาะ Postpaid)"
                      ></el-form-item>
                      <el-form-item
                        label="อัตราค่าบริการเสียง"
                      ></el-form-item>
                      <div class="row">
                        <div class="col-sm-6">
                          <el-form-item label="นาทีใด ๆ สูงสุด (บาท/นาที)">
                            <el-input-number v-model="form.average_voice_service" :precision="10" :max="999.9999999999" :min="null" style="width: 400px"></el-input-number>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item
                            label="เงื่อนไขอื่น ๆ คำอธิบาย (ภาษาไทย)"
                          >
                            <el-input
                              clearable
                              show-word-limit
                              maxlength="500"
                              v-model="form.average_voice_remark_th"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item
                            label="เงื่อนไขอื่น ๆ คำอธิบาย (ภาษาอังกฤษ)"
                          >
                            <el-input
                              clearable
                              v-model="form.average_voice_remark_en"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <br>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item
                            label="ค่าบริการด้านข้อมูล"
                          ></el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-4">
                          <el-form-item label="ค่าบริการ SMS (บาท/ข้อความ)">
                            <el-input-number v-model="form.average_sms_service" :precision="10" :max="999.9999999999" :min="null" style="width: 100%"></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-4">
                          <el-form-item label="ค่าบริการ MMS (บาท/ข้อความ)">
                            <el-input-number v-model="form.average_mms_service" :precision="10" :max="999.9999999999" :min="null" style="width: 100%"></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="col-sm-4">
                          <el-form-item label="บริการอินเทอร์เน็ต (บาท/MB)">
                            <el-input-number v-model="form.average_internet_service" :precision="10" :max="999.9999999999" :min="null" style="width: 100%"></el-input-number>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item
                            label="เงื่อนไขอื่น ๆ คำอธิบาย (ภาษาไทย)"
                          >
                            <el-input
                              clearable
                              v-model="form.average_other_service_th"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item
                            label="เงื่อนไขอื่น ๆ คำอธิบาย (ภาษาอังกฤษ)"
                          >
                            <el-input
                              clearable
                              v-model="form.average_other_service_en"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="col-xs-12" style="padding-bottom: 20px !important">
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-left"
                            @click="back()"
                          >
                            <i class="el-icon-back"></i>
                          </el-button>
                        </div>
                        <div class="col-xs-2"> </div>
                        <div class="col-xs-2">
                          <el-button
                            type="success"
                            @click="preview()"
                            >
                            บันทึก
                          </el-button>
                        </div>
                        <div class="col-xs-2"></div>
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-right"
                            @click="next()"
                            >
                            <i class="el-icon-right"></i>
                          </el-button>
                        </div>
                      </div>
                    </div>
                    <div v-if="active === 5" class="col-sm-12">
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item label="รูปแบบการคิดค่าบริการประเภทเสียง (วินาที/นาที)" required >
                            <el-radio-group v-model="form.service_charge_type" size="small">
                              <el-radio :label="'minute'">นาที</el-radio>
                              <el-radio :label="'second'">วินาที</el-radio>
                              <el-radio :label="null">ไม่ระบุ</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item
                            label="ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาไทย)"
                          >
                            <el-input
                              type="textarea"
                              :autosize="{ minRows: 4, maxRows: 4 }"
                              v-model="form.promotion_condition_th"
                              show-word-limit
                              maxlength="500"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item
                            label="ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาอังกฤษ)"
                          >
                            <el-input
                              type="textarea"
                              :autosize="{ minRows: 4, maxRows: 4 }"
                              v-model="form.promotion_condition_en"
                              show-word-limit
                              maxlength="500"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="col-xs-12" style="padding-bottom: 20px !important">
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-left"
                            @click="back()"
                          >
                            <i class="el-icon-back"></i>
                          </el-button>
                        </div>
                        <div class="col-xs-2"> </div>
                        <div class="col-xs-2">
                          <el-button
                            type="success"
                            @click="preview()"
                            >
                            บันทึก
                          </el-button>
                        </div>
                        <div class="col-xs-2"></div>
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-right"
                            @click="next()"
                            >
                            <i class="el-icon-right"></i>
                          </el-button>
                        </div>
                      </div>
                    </div>
                    <div v-if="active === 6" class="col-sm-12">
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item
                            label="สิทธิพิเศษ (ที่ไม่มีค่าใช้บริการ)"
                            show-word-limit
                            maxlength="200"
                          ></el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item
                            label="บริการความบันเทิง (ดูหนัง ทีวี ฟังเพลง) (ภาษาไทย)"
                          >
                            <el-input
                              clearable
                              v-model="form.privilege_content_th"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item
                            label="บริการความบันเทิง (ดูหนัง ทีวี ฟังเพลง) (ภาษาอังกฤษ)"
                          >
                            <el-input
                              clearable
                              v-model="form.privilege_content_en"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item
                            label="บริการโซเชียลมีเดีย (ภาษาไทย)"
                          >
                            <el-input
                              clearable
                              v-model="form.privilege_social_th"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item
                            label="บริการโซเชียลมีเดีย (ภาษาอังกฤษ)"
                          >
                            <el-input
                              clearable
                              v-model="form.privilege_social_en"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item label="บริการเกม (ภาษาไทย)">
                            <el-input
                              clearable
                              v-model="form.privilege_game_th"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item label="บริการเกม (ภาษาอังกฤษ)">
                            <el-input
                              clearable
                              v-model="form.privilege_game_en"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item label="พรีเมี่ยม (ภาษาไทย)">
                            <el-input
                              clearable
                              v-model="form.privilege_premium_th"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item label="พรีเมี่ยม (ภาษาอังกฤษ)">
                            <el-input
                              clearable
                              v-model="form.privilege_premium_en"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item label="บริการอุปกรณ์อื่น ๆ (ภาษาไทย)">
                            <el-input
                              clearable
                              v-model="form.privilege_device_th"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item
                            label="บริการอุปกรณ์อื่น ๆ (ภาษาอังกฤษ)"
                          >
                            <el-input
                              clearable
                              v-model="form.privilege_device_en"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item label="ให้บริการอื่น ๆ (ภาษาไทย)">
                            <el-input
                              clearable
                              v-model="form.privilege_other_th"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item label="ให้บริการอื่น ๆ (ภาษาอังกฤษ)">
                            <el-input
                              clearable
                              v-model="form.privilege_other_en"
                              show-word-limit
                              maxlength="500"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="col-xs-12" style="padding-bottom: 20px !important">
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-left"
                            @click="back()"
                          >
                            <i class="el-icon-back"></i>
                          </el-button>
                        </div>
                        <div class="col-xs-2"> </div>
                        <div class="col-xs-2">
                          <el-button
                            type="success"
                            @click="preview()"
                            >
                            บันทึก
                          </el-button>
                        </div>
                        <div class="col-xs-2"></div>
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-right"
                            @click="next()"
                            >
                            <i class="el-icon-right"></i>
                          </el-button>
                        </div>
                      </div>
                    </div>
                    <div v-if="active === 7" class="col-sm-12">
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item label="ย่านคลื่นความถี่"></el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item label="900 MHz" required>
                            <el-radio :label="1" v-model="form.signal_900">ใช่</el-radio>
                            <el-radio :label="0" v-model="form.signal_900">ไม่ใช่</el-radio>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item label="1800 MHz" required>
                              <el-radio :label="1" v-model="form.signal_1800">ใช่</el-radio>
                              <el-radio :label="0" v-model="form.signal_1800">ไม่ใช่</el-radio>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item label="2.1 GHz" required>
                              <el-radio :label="1" v-model="form.signal_2100">ใช่</el-radio>
                              <el-radio :label="0" v-model="form.signal_2100">ไม่ใช่</el-radio>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item label="ย่านคลื่นความถี่อื่น ๆ" required>
                            <el-radio :label="1" v-model="form.signal_other">ใช่</el-radio>
                            <el-radio :label="0" v-model="form.signal_other">ไม่ใช่</el-radio>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="col-xs-12" style="padding-bottom: 20px !important">
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-left"
                            @click="back()"
                          >
                            <i class="el-icon-back"></i>
                          </el-button>
                        </div>
                        <div class="col-xs-2"> </div>
                        <div class="col-xs-2">
                          <el-button
                            type="success"
                            @click="preview()"
                            >
                            บันทึก
                          </el-button>
                        </div>
                        <div class="col-xs-2"></div>
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-right"
                            @click="next()"
                            >
                            <i class="el-icon-right"></i>
                          </el-button>
                        </div>
                      </div>
                    </div>
                    <div v-if="active === 8" class="col-sm-12">
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item
                            label="ลิงก์เว็บไซต์ หรือลิงก์รายการส่งเสริมการขายของผู้ให้บริการ"
                          >
                            <el-input
                              clearable
                              v-model="form.promotion_link_url"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item
                            label="หมายเลข USSD สำหรับเปลี่ยนรายการส่งเสริมการขาย"
                          >
                            <el-input
                              clearable
                              v-model="form.promotion_ussd"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item
                            label="ลิงก์รูปโฆษณา หรือรายการส่งเสริมการขาย"
                          >
                            <el-input
                              clearable
                              v-model="form.promotion_banner"
                              type="textarea"
                              :rows="3"
                            ></el-input>
                          </el-form-item>
                        </div>
                      </div>

                      <div class="col-xs-12" style="padding-bottom: 20px !important">
                        <div class="col-xs-3">
                          <el-button round
                            type="primary"
                            class="pull-left"
                            @click="back()"
                          >
                            <i class="el-icon-back"></i>
                          </el-button>
                        </div>
                        <div class="col-xs-2"> </div>
                        <div class="col-xs-2">
                          <el-button
                            type="success"
                            @click="preview()"
                            >
                            บันทึก
                          </el-button>
                        </div>
                        <div class="col-xs-2"></div>
                        <div class="col-xs-3"></div>
                      </div>
                    </div>
                  </el-form>
                  <el-dialog title="การร้องขอแก้ไขข้อมูล" :visible.sync="dialogPreview" :width="'80%'">
                    <el-table :data="dialogData">
                      <el-table-column prop="name" label="หัวข้อ"></el-table-column>
                      <el-table-column prop="old" label="ข้อมูลเดิม"></el-table-column>
                      <el-table-column prop="new" label="ข้อมูลใหม่"></el-table-column>
                    </el-table>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogPreview = false">แก้ไขเพิ่มเติม</el-button>
                      <el-button type="success" @click="submit()">ส่งคำร้องขอแก้ไข</el-button>
                    </span>
                  </el-dialog>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
const moment = require("moment");
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      label_position: "top",
      active: 0,
      form: {},
      dialogPreview: false,
      dialogData: [],
      errData: []
    };
  },
  computed: {
    ...mapState({
      row_detail : store => store.Promotion.row_detail,
      promotion_status : store => store.Manage_request.promotion_status,
      schema_th : store => store.Manage_request.mobile_schema_th,
      schema_en : store => store.Manage_request.mobile_schema_en
    })
  },
  mounted(){
    if(JSON.stringify(this.row_detail).length <= 2){
      this.$router.push({name : 'Manage_mobileOperator'})
    }
    this.getPromotionStatus(this.row_detail.promotion_id)
    this.form = Object.assign({},this.row_detail)
    this.form.service_charge_type = this.form.service_charge_type ? this.form.service_charge_type.toLowerCase() : null
  },
  methods: {
    ...mapActions({
      addPromotion: "Promotion/addPromotion",
      validate: "Manage_request/validateEditRequest",
      getPromotionStatus: "Manage_request/getMobileRequestById",
      sendEditRequest: "Manage_request/sendEditRequest",
      getEditRevision: "Manag_revision/getMobileEditRevision"
    }),
    preview(){
      if(!this.validate(this.active)){
        return false
      }
      this.dialogData = []
      for(let key of this.schema_en){
        if(this.form[key] !== this.row_detail[key]){
          let old_item = this.row_detail[key]
          let new_item = this.form[key]
          old_item = ['start_sale_date','end_sale_date','start_service_date','end_service_date'].includes(key) && old_item
                    ? old_item = moment(old_item).add(543,'Y').format('DD/MM/YYYY') : old_item
          new_item = ['start_sale_date','end_sale_date','start_service_date','end_service_date'].includes(key) && new_item
                    ? new_item = moment(new_item).add(543,'Y').format('DD/MM/YYYY') : new_item
          this.dialogData.push({
            name : this.schema_th[this.schema_en.indexOf(key)],
            old : old_item,
            new : new_item
          })
        }
      }
      if(!this.dialogData.length){
        this.$confirm("ไม่พบการเปลี่ยนแปลงข้อมูล ต้องการยกเลิกการเปลี่ยนแปลงหรือไม่", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ย้อนกลับ",
          showCancelButton: true,
          type: "warning"
        }).then(() => {
          this.$router.push({name : 'Manage_mobileOperator'});
        }).catch(() =>{})
      }else{
        this.dialogPreview = true
      }
    },
    submit() {
      this.sendEditRequest(this.form)
    },
    validate: function(page){
      let pass = false;
      switch (page) {
        case 0:
          if(this.form.promotion_code == '') {
            this.$confirm("กรุณากรอกรหัสรายการส่งเสริมการขาย", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          }else if(this.form.promotion_name_th == '') {
            this.$confirm("กรุณากรอกชื่อรายการส่งเสริมการขาย (ภาษาไทย)", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          }else{
            pass = true
          }
        default:
          return pass = true
      }
      return pass
    },
    next() {
      this.steps(1+this.active)
    },
    back() {
      this.steps(0+this.active-1)
    },
    steps(number){
      let temp = this.active
      let going_page = number
      if (temp < number){
        for(let page = temp; page < number; page++){
          if(!this.validate(page)) {
            going_page = page
            break;
          }
        }
        this.active = going_page
      } else {
        this.active = going_page
      }
    },
  }
};
</script>
